module.exports = __webpack_public_path__ + "static/forbes-selected-1c0a0631fe1e598358de6a5306f765f9.svg";